
  import { mapGetters } from 'vuex';

  export default {
    computed: {
      ...mapGetters('pageContent', { jumbotron: 'getJumbotron' }),
      ...mapGetters('products', { coverType: 'getCoverType' }),
      ...mapGetters('rateChanges', { rateChanges: 'get' }),
      ...mapGetters('user', { customerNewsletterState: 'getCustomerNewsletterState', userNewsletterState: 'getUserNewsletterState' }),
      ...mapGetters('utils', { pageMeta: 'getMeta' }),
      breadcrumbs () {
        return this.pageMeta.breadcrumbs ? this.pageMeta.breadcrumbs : [];
      },
      isInsurance () {
        return this.$route.path.includes('insurance') || this.$route.path.includes('serious');
      },
      change () {
        return (this.rateChanges || []).find(p => p.institution.slug === this.$route.params.provider);
      },
      productBreadcrumbKey () {
        const coverTypeRoutes = ['income-protection', 'life-insurance', 'serious-illness', 'mortgage-protection'];
        if (coverTypeRoutes.some(p => this.$route.path.includes(p))) {
          return this.coverType && this.coverType.product;
        }
        return this.pageMeta.product;
      },
      showMailSignUp () {
        return (this.pageMeta.showNewsletterSignup && (!this.customerNewsletterState || this.userNewsletterState));
      },
      showHompageCTA () {
        return (this.pageMeta.showHompageCTA);
      }
    }
  };
